import { GET_ONE } from 'react-admin';

const dataBusinessUnitInvoicesRefundableAmount = (
  instance,
  type,
  { field, id, actionType, paymentRefundPspReference }
) => {
  const opt = {};
  switch (type) {
    case GET_ONE: {
      switch (field) {
        case 'refundableAmount':
          opt.url = `/user/billing/fleets/${localStorage.getItem('fleetID')}/invoices/${id}/refundableAmount`;
          opt.method = 'GET';
          break;

        case 'refundNote':
          opt.url = `/user/billing/fleets/${localStorage.getItem('fleetID')}/invoices/${id}/refundNote${
            paymentRefundPspReference ? `?paymentRefundPspReference=${paymentRefundPspReference}` : ''
          }`;
          opt.method = 'GET';
          opt.responseType = 'blob';
          opt.headers = {
            Accept: 'application/pdf',
          };
          break;

        case 'invoicePdf':
          opt.url = `/user/billing/fleets/${localStorage.getItem('fleetID')}/invoices/${id}/pdf`;
          opt.method = 'GET';
          opt.responseType = 'blob';
          opt.headers = {
            Accept: 'application/pdf',
          };
          break;

        default:
          break;
      }
      break;
    }
    default:
      throw new Error(`Unsupported action type ${actionType}`);
  }

  return instance(opt);
};

export default dataBusinessUnitInvoicesRefundableAmount;
